// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"high-level"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20.94 11.46C20.67 9.18 19.55 7.1 17.8 5.62C16.76 4.74 15.53 4.12 14.23 3.79M8.56 20.82C10.68 21.7 13.05 21.73 15.19 20.92C16.37 20.47 17.43 19.78 18.31 18.91M6.65 5.26C4.81 6.62 3.55 8.63 3.14 10.89C2.89 12.29 2.97 13.71 3.37 15.05M14 3.5C14 4.6 13.1 5.5 12 5.5C10.9 5.5 10 4.6 10 3.5C10 2.4 10.9 1.5 12 1.5C13.1 1.5 14 2.4 14 3.5ZM21.5 17C21.5 18.1 20.6 19 19.5 19C18.4 19 17.5 18.1 17.5 17C17.5 15.9 18.4 15 19.5 15C20.6 15 21.5 15.9 21.5 17ZM6.5 17C6.5 18.1 5.6 19 4.5 19C3.4 19 2.5 18.1 2.5 17C2.5 15.9 3.4 15 4.5 15C5.6 15 6.5 15.9 6.5 17Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-high-level')
export default class HighLevelIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'high-level',
    }
  }
}
